export enum EHintType {
  ERROR_LOCKED_CELLPHONE_ON_REFURBED = 'ERROR_LOCKED_CELLPHONE_ON_REFURBED',
  WARNING_SELL_NEW_ITEM_ON_REFURBED = 'WARNING_SELL_NEW_ITEM_ON_REFURBED',
  NONE = 'NONE',
}
